import { $body } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Fixed Anchor Menu
 */
const FixedAnchorMenu = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		FIXED_ANCHOR_MENU: '.fixed-anchor-menu',
	};

	/**
	 * Fixed Anchor Menu
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class FixedAnchorMenu extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			const sectionSelectors = [
				...this.$element.find('a').map((i, el) => {
					try {
						const url = new URL(el.href);
						return url.hash;
					} catch (e) {
						return null
					}
				})
			].filter(Boolean);

			const observer = new IntersectionObserver((entries) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						this.$element.find('a').removeClass('active');

						if (entry.target.id) {
							const id = entry.target.id;
							this.$element.find(`a[href*="#${id}"]`).addClass('active');
						} else {
							this.$element.find('a[href="#"]').addClass('active');
						}
					}
				}
			}, {
				rootMargin: '-50% 0% -50% 0%',
				threshold: 0
			});

			const $sections = $body.find(sectionSelectors.join(','));
			$sections.each((i, el) => {
				observer.observe(el);
			});

			this.$element.find('a[href="#"]').on('click', (e) => {
				e.preventDefault();

				$('html, body').animate({
					scrollTop: 0
				});
			});

			observer.observe(document.querySelector('.banner'));
		}
	}

	return FixedAnchorMenu._getElements($body.find(Selector.FIXED_ANCHOR_MENU), FixedAnchorMenu);
})();

export default FixedAnchorMenu;
